export default "__VITE_ASSET__41a7e092__"